export function upperSnakeToKebab(value: string): string {
    return value.toLowerCase().replace(/_/g, '-');
}

export function toDecimal(value: string): string {
    return value.trim().replace(',', '.');
}
